export default __webpack_public_path__ + "static/media/frbannermobile.052f3e0b.jpg";